var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32C7.67395 32 0.5 24.826 0.5 16C0.5 7.17395 7.67395 0 16.5 0C25.326 0 32.5 7.17395 32.5 16C32.5 24.826 25.326 32 16.5 32ZM16.5 2.23256C8.9093 2.23256 2.73256 8.4093 2.73256 16C2.73256 23.5907 8.9093 29.7674 16.5 29.7674C24.0907 29.7674 30.2674 23.5907 30.2674 16C30.2674 8.4093 24.0907 2.23256 16.5 2.23256Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2869 21.3283C12.0041 21.3283 11.7213 21.2241 11.498 21.0009C11.0664 20.5692 11.0664 19.8548 11.498 19.4232L19.9223 10.999C20.3539 10.5674 21.0683 10.5674 21.4999 10.999C21.9316 11.4306 21.9316 12.1451 21.4999 12.5767L13.0757 21.0009C12.8673 21.2241 12.5696 21.3283 12.2869 21.3283Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7111 21.3283C20.4283 21.3283 20.1455 21.2241 19.9223 21.0009L11.498 12.5767C11.0664 12.1451 11.0664 11.4306 11.498 10.999C11.9297 10.5674 12.6441 10.5674 13.0757 10.999L21.4999 19.4232C21.9316 19.8548 21.9316 20.5692 21.4999 21.0009C21.2767 21.2241 20.9939 21.3283 20.7111 21.3283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.74df9fb0438ef08c1a336aba8e47891b.svg";
export { ForwardRef as ReactComponent };